<button mat-button color="primary" disableRipple="true" [matMenuTriggerFor]="themeMenu">{{ activeTheme }}</button>
<mat-menu #themeMenu="matMenu">
  @for (theme of availableThemes; track theme) {
    <button mat-menu-item (click)="themeChange(theme)">
      {{ theme | uppercase }}
    </button>
  }
</mat-menu>
